import { useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';
import { resolveVendorBySalesforceId } from '~/services/vendorLookup';

import { isValidSalesforceId } from '~/utils/validateSalesforceId';

export const vendorSearchQueryKeys = {
  all: ['vendor-search'] as const,
  list: (filter: string, limit: number) => [...vendorSearchQueryKeys.all, filter, limit] as const,
};

type Params = {
  filter: string;
  limit?: number;
  enabled?: boolean;
};

type VendorSearchResult = {
  result: Array<App.Vendor>;
  total: number;
};

export function useVendorSearch({ filter, limit = 10, enabled = true }: Params) {
  return useQuery<VendorSearchResult>({
    queryKey: vendorSearchQueryKeys.list(filter, limit),
    queryFn: async () => {
      if (isValidSalesforceId(filter)) {
        try {
          const vendor = await resolveVendorBySalesforceId(filter);
          return { result: vendor ? [vendor] : [], total: vendor ? 1 : 0 };
        } catch {
          return { result: [], total: 0 };
        }
      }
      return VendorsService.getVendorByName(filter, limit, 1);
    },
    enabled: enabled && filter.length >= 2,
    staleTime: 60 * 1000,
  });
}
